import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MarketStatProps {
  title: string;
  value: string;
  icon: LucideIcon;
  className?: string;
}

export default function MarketStat({ title, value, icon: Icon, className = '' }: MarketStatProps) {
  return (
    <div className={`bg-gray-800/50 backdrop-blur-sm rounded-lg p-4 ${className}`}>
      <div className="flex items-center space-x-3">
        <Icon className="w-5 h-5 text-purple-500" />
        <div>
          <h3 className="text-sm text-gray-400">{title}</h3>
          <p className="text-lg font-bold text-white">{value}</p>
        </div>
      </div>
    </div>
  );
}